import { IconButton, SettingsFilled } from "@bcc-ui/ui-components";
import * as React from "react";

import style from "./dev-tools-button.scss";
import { resolveColor } from "utils/commonFunctions";

interface Props {
    onClick: () => void;
}

export const DevToolsButton = (props: Props) => {
    return (
        <IconButton className={style.trigger} onClick={props.onClick}>
            <SettingsFilled color={resolveColor("--theme-icon-fill-white")} />
        </IconButton>
    );
};
